/**
 * Mapping of source IDs to their display information
 * This file should be updated when new sources are added
 */
export interface SourceInfo {
  name: string;
  url: string;
}

export const SOURCES: Record<string, SourceInfo> = {
  ara: {
    name: "Ara.cat",
    url: "https://www.ara.cat"
  },
  opendata_agenda_cultural: {
    name: "Open Data Agenda Cultural",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  opendata_punts_informacio_turistica: {
    name: "Open Data Punts d'Informació Turística",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  opendata_culturailleure_cinemesteatresauditoris: {
    name: "Open Data Cultura i Lleure - Cinemes, Teatres i Auditoris",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  opendata_cultura_biblioteques_museus: {
    name: "Open Data Cultura - Biblioteques i Museus",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  opendata_equipament_restaurants: {
    name: "Open Data Equipament Restaurants",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  opendata_culturailleure_espaismusicacopes: {
    name: "Open Data Cultura i Lleure - Espais de Música i Copes",
    url: "https://opendata-ajuntament.barcelona.cat"
  },
  ticketmaster: {
    name: "Ticketmaster",
    url: "https://www.ticketmaster.es"
  },
  viasona: {
    name: "Viasona",
    url: "https://www.viasona.cat"
  },
  sensacine: {
    name: "Sensacine",
    url: "https://www.sensacine.com"
  },
  teatre_barcelona: {
    name: "Teatre Barcelona",
    url: "https://www.teatrebarcelona.com"
  },
  el_culturista: {
    name: "El Culturista",
    url: "https://elculturista.cat"
  }
};

/**
 * Get source information by ID
 * @param sourceId - The source ID from the backend
 * @returns SourceInfo if found, null otherwise
 */
export const getSourceInfo = (sourceId: string): SourceInfo | null => {
  return SOURCES[sourceId] || null;
};

/**
 * Get multiple source information by IDs
 * @param sourceIds - Array of source IDs from the backend
 * @returns Array of SourceInfo (only valid sources)
 */
export const getSourcesInfo = (sourceIds: string[]): SourceInfo[] => {
  return sourceIds
    .map((id) => getSourceInfo(id))
    .filter((info): info is SourceInfo => info !== null);
};
